export const pinia = createPinia()